import { render, staticRenderFns } from "./showOrk.vue?vue&type=template&id=4c80e8e2&"
import script from "./showOrk.vue?vue&type=script&lang=js&"
export * from "./showOrk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports